import { intersection } from 'lodash-es';

import type { FcmValues, Viewer } from './types';

export function isTrafficDisabled({
	gradualOpeningFcm,
	viewer,
}: {
	gradualOpeningFcm: FcmValues['gradualOpening'];
	viewer: Viewer;
}) {
	if (!gradualOpeningFcm) return false;

	const {
		traffic_percentage: trafficPercentage,
		safe_listed_user_identifiers: safeListedUserIdentifiers = [],
		block_listed_user_identifiers: blockListedUserIdentifiers = [],
	} = gradualOpeningFcm;
	const userIdentifiers = [...(viewer.user ? [viewer.user.id] : []), viewer.uuid];
	const isUserSafeListed = !!intersection(safeListedUserIdentifiers, userIdentifiers).length;
	const isUserBlockListed = !!intersection(blockListedUserIdentifiers, userIdentifiers).length;

	if (isUserBlockListed) return true;
	if (isUserSafeListed) return false;
	return trafficPercentage <= Math.random() * 100;
}
